module.exports = __webpack_public_path__ + "static/media/copy.bc457298.svg";